import { Box, Button, TextField } from '@mui/material';
import TextFieldComponent from 'components/TextFieldComponent';
import React, { ChangeEvent, useState } from 'react';
import defaultImagePage4 from '../../../../assets/images/proposalImagens/childrenImage.jpeg';

interface FormsProposalProps {
  formData: { imagePage4?: File | null; monthlyCall?: string };
  onChange: (data: { imagePage4?: File | null; monthlyCall?: string }) => void;
  goToNextPage: () => void;
}

const FormsProposalFourth: React.FC<FormsProposalProps> = ({
  formData,
  onChange,
  goToNextPage,
}) => {
  const [previewImage, setPreviewImage] = useState<string | null>(
    formData.imagePage4
      ? URL.createObjectURL(formData.imagePage4)
      : defaultImagePage4,
  );

  function handleChange(event: ChangeEvent<HTMLInputElement>): void {
    const { name, value, files } = event.target;
    if (name === 'imagePage4') {
      const file = files && files[0] ? files[0] : null;
      onChange({
        ...formData,
        [name]: file,
      });
      setPreviewImage(file ? URL.createObjectURL(file) : defaultImagePage4);
    } else {
      onChange({
        ...formData,
        [name]: value,
      });
    }
  }

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 3,
        backgroundColor: '#202940',
        width: '100%',
        height: '80%',
        boxShadow: '0 4px 24px rgba(24, 19, 19, 0.25)',
        padding: 3,
        gap: 2,
        '@media (max-width: 600px)': {
          padding: 2,
          width: '100%',
        },
      }}
    >
      <Box
        component="h2"
        sx={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#fff', mb: 2 }}
      >
        Preencher dados pagina 4
      </Box>
      <TextField
        label="Mensalidade"
        name="monthlyCall"
        type="text"
        value={formData.monthlyCall || ''}
        onChange={handleChange}
        sx={{ width: '100%' }}
      />
      <Box
        component="img"
        src={previewImage || undefined}
        alt="Preview Image Page 4"
        sx={{ width: '20%', height: 'auto', borderRadius: 1, mb: 2 }}
      />
      <TextField
        variant="outlined"
        label="Imagem da Página 4"
        fullWidth
        type="file"
        name="imagePage4"
        InputLabelProps={{ shrink: true }}
        onChange={handleChange}
        sx={{ borderRadius: 1 }}
      />
      <Button
        onClick={goToNextPage}
        sx={{
          backgroundColor: '#1976d2',
          color: 'white',
          '&:hover': {
            backgroundColor: '#115293',
          },
        }}
        variant="contained"
      >
        Salvar
      </Button>
    </Box>
  );
};

export default FormsProposalFourth;
